<template>
  <div class="map-page">
    <div class="map" ref="map" />

    <div
      v-if="address"
      class="address"
    >
      <div class="address__icon-wrapper">
        <BaseIcon icon="pin" />
      </div>
      <p class="address__text">
        {{ address }}
      </p>

      <div class="address__coords">{{ coords }}</div>
    </div>

    <div class="panel">
      <BaseButton @click="onSave">
        Сохранить
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/Base/BaseButton'
import BaseIcon from '@/components/Base/BaseIcon'

export default {
  name: 'AppMap',
  components: {
    BaseIcon,
    BaseButton
  },
  data () {
    return {
      initialAddress: {
        address: '',
        coords: []
      },
      address: '',
      coords: []
    }
  },
  async mounted () {
    await this.fetchMapData()
    this.initMap()
  },
  methods: {
    initMap () {
      const ymaps = window.ymaps
      const map = this.$refs.map

      ymaps.ready(() => {
        const initialPlacemark = new ymaps.Placemark(this.coords)

        const myMap = new ymaps.Map(map, {
          center: this.coords,
          zoom: 12,
          controls: ['zoomControl']
        })

        myMap.geoObjects
          .add(initialPlacemark)

        const searchControl = new ymaps.control.SearchControl({
          options: { provider: 'yandex#map' }
        })

        searchControl.events.add('submit', async function () {
          const searchValue = searchControl.getRequestString()
          const res = await ymaps.geocode(searchValue, { results: 1 })
          const firstGeoObject = res.geoObjects.get(0)
          const coords = firstGeoObject.geometry.getCoordinates()

          this.address = searchValue
          this.coords = coords

          myMap.geoObjects
            .remove(initialPlacemark)
        }, this)

        myMap.controls
          .add(searchControl)
      })
    },
    async fetchMapData () {
      try {
        const { data } = await this.$api.field.change(this.$route.params.id)
        const geocode = data?.data?.geocode

        this.initialAddress.address = this.address = geocode.formattedAddress
        this.initialAddress.coords = this.coords = [geocode.lat, geocode.lng]
      } catch (e) {
        console.log(e)
      }
    },
    async onSave () {
      if (
        this.initialAddress.address === this.address &&
        this.initialAddress.coords[0] === this.coords[0] &&
        this.initialAddress.coords[1] === this.coords[1]
      ) {
        return
      }

      const body = {
        formattedAddress: this.address,
        lat: this.coords[0],
        lng: this.coords[1]
      }

      try {
        const res = await this.$api.field.changeGeocode(this.$route.params.id, body)

        if (res.data.status === 'ok') {
          alert('Изменения успешно пременены.')
        } else {
          alert('Произошла ошибка. Не удалось сохранить изменения.')
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map-page {
  .map {
    height: 700px;
  }

  .address {
    display: flex;
    align-items: center;
    margin-top: 25px;

    &__icon-wrapper {
      color: $brand-color;
    }

    &__text {
      margin-left: 12px;
    }

    &__coords {
      color: #A1A1A8;
      padding: 10px 16px;
      background: #242428;
      border-radius: 10px;
      margin-left: 24px;
    }
  }

  .panel {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
